import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import Label from '../../atoms/display/Label'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import { CompanyRepresentative } from '../../../types/Company'
import { CompanyActions } from '../../../store/company'

type Props = {
  open: boolean
  representative: CompanyRepresentative
  onClose: () => void
}

export default function CompanyRepresentativeCertificationDeleteDialog({ open, representative, onClose }: Props) {
  const dispatch = useDispatch()

  const handleDelete = useCallback(() => {
    dispatch(
      CompanyActions.deleteRepresentativeCertificationFiles({
        companyId: representative.company.id,
        representativeId: representative.id,
      })
    )
    onClose()
  }, [dispatch, onClose, representative])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="本人確認書類の削除"
      actions={
        <FlexRow>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
          <Button color="caution" onClick={handleDelete}>
            削除
          </Button>
        </FlexRow>
      }
    >
      <FlexColumn>
        <Label text={`本人確認書類（${representative.certificationFiles.length}件）をすべて削除しますか？`} />
        <Label text="削除した書類は元に戻せません。" />
      </FlexColumn>
    </Dialog>
  )
}
